
import { useTranslation } from "react-i18next";
import { AgGridReact } from "ag-grid-react";
import React, { useState, useEffect, useMemo, useRef, useContext } from "react";
import { ColDef, ICellRendererParams, IServerSideDatasource } from "ag-grid-community";
import { Photo } from "@mui/icons-material";

import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";
import { fetchRaCustomerReports } from "../../ra-search/services/http.services";
import { AxiosError } from "axios";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import { setSnackbar } from "../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../util/state/globalVariables";
import { getImageByPosition } from "../../../network/ra-detail/services/http.services";
import { useRecoilState } from "recoil";
import { raDetailState } from "../state";


interface ReportListProps {
    raId: string,
    status: string | null,
    scenario: number,
    setCanBeConfirmed: (b: boolean) => void,
    setCanBeUnconfirmed: (b: boolean) => void,
    setRaCrStatus: (s: string) => void,
}

const ReportList = (props: ReportListProps) => {
    const { t, i18n } = useTranslation(['network', 'translation']);
    const { dispatchGlobalData } = useContext(GlobalContext);
    const [reportsStatus, setReportsStatus] = useState<String>('0');
    const [raDetail, setRaDetail] = useRecoilState(raDetailState);
    const canBeConfirmedStatus = '2';
    const canBeUnconfirmedStatus = '3';

    // useEffect(() => {
    //     console.log({ raId: props.raId });
    // }, [props.raId])

    //raDetail?.generalInfo?.raState?.description

    const serverSideDatasource = useMemo<IServerSideDatasource>(() => ({
        getRows(params) {
            fetchRaCustomerReports(props.raId,props.scenario)
                .then((response: any) => {
                    if (!response.data || !Array.isArray(response.data.customerReports)) {
                        throw new Error("Invalid response format");
                    }
                    console.log("response.data:", response.data);
                    console.log("response.data.status:", response.data.status);

                    setReportsStatus(response.data.status);
                    props.setRaCrStatus(response.data.status)
                    props.setCanBeConfirmed(response.data.status === canBeConfirmedStatus)
                    props.setCanBeUnconfirmed(response.data.status === canBeUnconfirmedStatus)
                    params.success({
                        rowData: response.data.customerReports,
                        rowCount: response.data.customerReports.length
                    });
                })
                .catch((err: AxiosError) => {
                    console.error("Error fetching reports:", err); // Debug
                    params.fail();

                    dispatchGlobalData({
                        type: setSnackbar,
                        payload: {
                            snackbar: {
                                message: t('translation:error.tryLater'),
                                type: snackbarTypes.error,
                                show: true,
                                autoClose: true
                            }
                        }
                    });
                });
        },

    }), [props.raId, props.status]);

    const gridRef = useRef<AgGridReact>(null);
    const columnDefs = useMemo<ColDef[]>(() => [
        {
            headerName: t('raDetail.customerReports.headerName.type'),
            valueGetter: ({ data }) => `${getScenarioLabel(data)} - ${getTypeLabel(data)}`,
            width: 280
        },
        {
            headerName: t('raDetail.customerReports.headerName.note'),
            field: 'note',
            flex: 2
        },
        {
            headerName: t('raDetail.customerReports.headerName.creationDate'),
            field: 'createDate',
            valueFormatter: ({ value }) =>
                value ? new Date(value).toLocaleString('it-IT', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                }) : '',
            width: 250
        },
        {
            headerName: t('raDetail.customerReports.headerName.status'),
            valueGetter: ({ }) => `${getStatusLabel()}`,
            width: 200
        },
        {
            headerName: t('raDetail.customerReports.headerName.screenshot'),
            cellRenderer: (params: ICellRendererParams) => {
                if (!params.data || !params.data.images) return null;

                return (
                    <div style={{ display: "flex", justifyContent: "center", gap: "5px", width: "100%" }}>
                        {params.data.images.map((imgId: any, index: number) => (
                            <button
                                key={index}
                                onClick={() => handleImageClick(imgId.id)}
                                style={{
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    padding: 0, // Rimuove padding extra
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "30px", // Imposta larghezza fissa per le icone
                                    height: "30px"
                                }}
                            >
                                <Photo />
                            </button>
                        ))}
                    </div>
                );
            },
            width: 110 // Regola la larghezza per adattarsi a 3 icone
        },
    ], [i18n.language, reportsStatus]);



    const getScenarioLabel = (data: any) => {
        console.log("data.scenario:", data.scenario);

        switch (data.scenario) {
            case '1':
                return "Check-Out";
            case '2':
                return "Check-In";
            default:
                return "Undefined";
        }
    }


    const getTypeLabel = (data: any) => {

        console.log("data.category:", data.category);
        console.log("data.subCategory:", data.subCategory);

        let strTypeCat = '';
        let strTypeSubCat = '';



        switch (data.category) {
            case '1':
                strTypeCat = "interno";
                break;
            case '2':
                strTypeCat = "esterno";
                break;
            case '3':
                strTypeCat = "cruscotto";
                break;
            case '4':
                strTypeCat = "generica";
                break;
        }


        switch (data.subCategory) {
            case '0':
                strTypeSubCat = "no-subcat";
                break;
            case '1':
                strTypeSubCat = "ante-sx";
                break;
            case '2':
                strTypeSubCat = "ante-dx";
                break;
            case '3':
                strTypeSubCat = "post-sx";
                break;
            case '4':
                strTypeSubCat = "post-dx";
                break;
            case '5':
                strTypeSubCat = "km";
                break;
            case '6':
                strTypeSubCat = "fuel";
                break;
            case '7':
                strTypeSubCat = "battery";
                break;
        }

        return t('raDetail.customerReports.category.' + strTypeCat) + ' - ' + t('raDetail.customerReports.subcategory.' + strTypeSubCat);

    }


    const getStatusLabel = () => {

        console.log("reportsStatus:", reportsStatus);

        let statusStr = '';
        switch (reportsStatus) {
            case '1':
                statusStr = "draft";
                break;
            case '2':
                statusStr = "confclient";
                break;
            case '3':
                statusStr = "confoper";
                break;
            case '4':
                statusStr = "unconfoper"
                break;
            default:
                statusStr = "undefined";
        }

        return t('raDetail.customerReports.status.' + statusStr)
    }


    const handleImageClick = async (imgId: any) => {

        let params = imgId.split('-');
        console.log("handleImageClick id:", params[0]);
        console.log("handleImageClick position:", params[1]);

        getImageByPosition(params[0], params[1])
            .then((response: any) => {
                console.log("downloadImg response:", response);
                downloadImage(response.content, 'CR_IMG-' + response.cr_id + ' - ' + response.position);
            })
            .catch((error: any) => {
                console.error("Errore nel download dell'immagine:", error);
            });
    }

    const downloadImage = async (base64String: string, fileName: string) => {
        // Rimuove il prefisso "data:image/png;base64,"
        const base64Data = base64String.replace(/^data:image\/[a-z]+;base64,/, "");

        const response = await fetch(`data:image/png;base64,${base64Data}`);
        const blob = await response.blob();

        const blobUrl = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = fileName;

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
    };

    return (
        <AgGridCustomTable
            gridRef={gridRef}
            rowModelType='serverSide'
            serverSideInfiniteScroll
            serverSideDatasource={serverSideDatasource}
            columnDefs={columnDefs}
            gridOptions={
                {
                    defaultColDef: { lockPinned: true, resizable: true, suppressSizeToFit: false },
                    onGridReady: (event) => {
                        event.api.sizeColumnsToFit()
                    }
                }
            }
        />
    )
}

export default ReportList;
